import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { isSizeLarge, noop } from '../utils';
import { sizeType } from '../propTypes';
var propTypes = {
  bsSize: sizeType,
  label: PropTypes.string,
  onClick: PropTypes.func
};
var defaultProps = {
  label: 'Clear',
  onClick: noop
};

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var bsSize = _ref.bsSize,
      className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["bsSize", "className", "label", "onClick"]);

  return React.createElement("button", _extends({}, props, {
    "aria-label": label,
    className: cx('close', 'rbt-close', {
      'rbt-close-lg': isSizeLarge(bsSize)
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();

      _onClick(e);
    },
    type: "button"
  }), React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), React.createElement("span", {
    className: "sr-only"
  }, label));
};

ClearButton.propTypes = propTypes;
ClearButton.defaultProps = defaultProps;
export default ClearButton;